// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rsrl","col":"styles_col__PJQLI"};